/**
 * 留言未读数
 * @author Kody
 * @see http://api.umucdn.cn/project/232/interface/api/4427
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export const getMessageUnread = (): Promise<IStatusResponse> => {
    return fetchData(Api.PROFILE_MESSAGE_UNREAD, {});
};
